import { Weekday } from 'rrule';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { DayPicker, DaysOfWeek, Text } from '@frontend/design-system';
import { getDaysOfWeekFromRRuleDay } from '../../../../rrule-helper';

type Props = {
  daysPicked: Weekday[];
  onDayToggle: ({ selectedDays }: { selectedDays: DaysOfWeek[] }) => void;
};

const DAY_ORDER: DaysOfWeek[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const sortDaysChronologically = (days: DaysOfWeek[]): DaysOfWeek[] =>
  [...days].sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b));

export const DayPickerWithSelectedDays = ({ daysPicked, onDayToggle }: Props) => {
  const { t } = useTranslation('schedule-settings');
  const selectedDays = sortDaysChronologically(daysPicked.map(getDaysOfWeekFromRRuleDay));

  return (
    <>
      <DayPicker selectedDays={selectedDays} config={{ onDayToggle }} />
      {selectedDays.length > 0 && (
        <Text size='small' css={{ marginTop: theme.spacing(0.5) }}>
          {t('Selected: {{selectedDays}}.', { selectedDays: selectedDays.join(', ') })}
        </Text>
      )}
    </>
  );
};
